import { useQuery } from '@tanstack/react-query';
import { fetchQuestionCount } from '../api/questionCount';
import { useCertStore } from '../stores/certStore';
import type { QuestionCountParams } from '../api/questionCount';

export function useQuestionCount(params: QuestionCountParams, enabled = true) {
  const certCode = useCertStore((s) => s.certCode);
  return useQuery({
    queryKey: ['question-count', certCode, params],
    queryFn: () => fetchQuestionCount(params, certCode),
    enabled,
    staleTime: 30_000,
  });
}
